import { APP_TERMS } from "./app-terms";
import { dashboard, menuicon06, menuicon08, menuicon13, patients } from "./components/imagepath";

export const AppLocales = {
  enUs: 'enUs',
};
export const DEFAULT_DEBOUNCE_INTERVAL = 500;
export const CASE_FORM_TYPES = {
  patientDetails: 'PATIENT_DETAILS',
  studyPurpose: 'STUDY_PURPOSE',
  addServices: 'ADD_SERVICES',
  uploadFiles: 'UPLOAD_FILES',
};
export const EDIT_CASE_FORM_TYPES = {
  uploadFiles: 'UPLOAD_FILES',
  comments: 'COMMENTS'
}
export const UPLOAD_STATUS = {
  success:"SUCCESS",
  failure: "FAILURE"
}
export const APP_USER_TYPES = {
  clinicUser: 'clinicUser',
};
export const APP_MASTER_TYPES = {
  service: 'service',
};
export const STUDY_PURPOSES = [
  { label: APP_TERMS.airway_label, fieldName: 'airwayFlag' },
  { label: APP_TERMS.generic_general, fieldName: 'generalFlag' },
  { label: APP_TERMS.impaction_label, fieldName: 'impactionFlag' },
  { label: APP_TERMS.implant_label, fieldName: 'implantFlag' },
  { label: APP_TERMS.orthodontic_label, fieldName: 'orthodonticFlag' },
  { label: APP_TERMS.pathology_label, fieldName: 'pathologyFlag' },
  { label: APP_TERMS.sinus_label, fieldName: 'sinusFlag' },
  { label: APP_TERMS.tmd_pain_label, fieldName: 'painFlag' },
];
export const SIDEBAR_ITEMS = [
  {
    to: '/user/admin-dashboard',
    id: 'dashboard',
    title: 'Dashboard',
    icon: dashboard,
  },
  {
    id: 'patients',
    title: 'Patients',
    icon: patients,
    to: '/user/patientslist',
    children: [
      {
        id: 'patientlist',
        to: '/user/patientslist',
        title: 'Patients List',
        activeClassName: 'patient-list',
      },
      {
        id: 'addpatient',
        to: '/user/addpatients',
        title: 'Add Patients',
        activeClassName: 'add-patient',
      },
    ],
  },
  {
    id: 'users',
    title: 'Staff',
    icon: menuicon08,
    to: '/user/userslist',
    children: [
      {
        id: 'stafflist',
        to: '/user/userslist',
        title: 'Staff List',
        activeClassName: 'user-list',
      },
    ],
  },
  {
    id: 'branches',
    title: 'Branch',
    icon: menuicon06,
    to: '/user/branchlist',
    children: [
      {
        id: 'branchlist',
        to: '/user/branchlist',
        title: 'Branch List',
        activeClassName: 'branch-List',
      },
    ],
  },
  {
    id: 'cases',
    title: APP_TERMS.generic_case,
    icon: menuicon13,
    to: '/user/case/new',
    children: [
      {
        id: 'casenew',
        to: '/user/case/new',
        title: 'Assigned',
      },
      {
        id: 'casesubmitted',
        to: '/user/case/submitted',
        title: 'Submitted',
      },
      {
        id: 'caseaccepted',
        to: '/user/case/accepted',
        title: 'Accepted',
      },
      {
        id: 'caserejected',
        to: '/user/case/rejected',
        title: 'Rejected',
      },
      {
        id: 'casecompleted',
        to: '/user/case/completed',
        title: 'Completed',
      },
    ],
  },
  {
    id: 'revenue',
    title: 'Revenue',
    icon: menuicon08,
    to: '/user/radiologist-invoice-list',
    children: [
      {
        id: 'radiologist-invoice-list',
        to: '/user/radiologist-invoice-list',
        title: 'List',
        activeClassName: 'radiologist-invoice-list',
      },
    ],
  }
];

export const LOGIN_FORM_TYPES = {
  NEW_PASSWORD_REQUIRED: 'NEW_PASSWORD_REQUIRED',
  CUSTOM_CHALLENGE: 'CUSTOM_CHALLENGE',
};
export const WORD_FILE_MIME_TYPE = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
export const DATE_FORMAT = "MM-DD-YYYY";